import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.every.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.map.js";
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, unref as _unref, resolveDirective as _resolveDirective, Teleport as _Teleport, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "list-page-table-panel list-page-table-panel--fill"
};
const _hoisted_2 = {
  class: "filter-bar-field is-wide relative"
};
const _hoisted_3 = {
  class: "data-table-shell"
};
const _hoisted_4 = {
  class: "data-table-scroll data-table-scroll--fill"
};
const _hoisted_5 = {
  class: "data-table text-sm min-w-[960px]"
};
const _hoisted_6 = {
  class: "data-table-head"
};
const _hoisted_7 = {
  class: "data-table-th text-left w-10"
};
const _hoisted_8 = ["checked"];
const _hoisted_9 = {
  key: 1
};
const _hoisted_10 = {
  class: "data-table-td is-center"
};
const _hoisted_11 = ["checked", "onChange"];
const _hoisted_12 = {
  class: "data-table-td font-mono text-slate-900"
};
const _hoisted_13 = {
  class: "data-table-td"
};
const _hoisted_14 = {
  class: "flex items-center gap-2"
};
const _hoisted_15 = {
  class: "w-8 h-8 rounded-full status-badge is-neutral flex items-center justify-center text-xs font-medium"
};
const _hoisted_16 = {
  class: "text-sm text-slate-900"
};
const _hoisted_17 = {
  class: "text-xs text-slate-500"
};
const _hoisted_18 = {
  class: "data-table-td is-right money-text"
};
const _hoisted_19 = {
  class: "data-table-td"
};
const _hoisted_20 = {
  class: "text-sm text-slate-900"
};
const _hoisted_21 = {
  class: "text-xs text-slate-500"
};
const _hoisted_22 = {
  class: "data-table-td"
};
const _hoisted_23 = {
  class: "data-table-td text-slate-600"
};
const _hoisted_24 = {
  class: "data-table-td is-center data-table-sticky-right data-table-sticky-action"
};
const _hoisted_25 = {
  class: "flex items-center justify-center gap-1"
};
const _hoisted_26 = ["onClick"];
const _hoisted_27 = ["onClick"];
const _hoisted_28 = ["onClick"];
const _hoisted_29 = {
  class: "flex-shrink-0 flex items-center justify-between px-6 py-4 border-b border-slate-200"
};
const _hoisted_30 = {
  class: "text-sm text-slate-500 font-mono"
};
const _hoisted_31 = {
  class: "flex items-center gap-3"
};
const _hoisted_32 = {
  class: "flex-1 overflow-y-auto min-h-0 p-6 space-y-4"
};
const _hoisted_33 = {
  class: "bg-slate-50 rounded-xl p-4"
};
const _hoisted_34 = {
  class: "grid grid-cols-2 gap-4"
};
const _hoisted_35 = {
  class: "text-sm text-slate-900 font-mono"
};
const _hoisted_36 = {
  class: "text-sm text-slate-900"
};
const _hoisted_37 = {
  class: "bg-slate-50 rounded-xl p-4"
};
const _hoisted_38 = {
  class: "grid grid-cols-2 md:grid-cols-4 gap-4"
};
const _hoisted_39 = {
  class: "text-xl money-text"
};
const _hoisted_40 = {
  class: "text-sm text-slate-900"
};
const _hoisted_41 = {
  class: "text-sm text-emerald-600 font-medium"
};
const _hoisted_42 = {
  class: "text-sm text-slate-900"
};
const _hoisted_43 = {
  class: "bg-slate-50 rounded-xl p-4"
};
const _hoisted_44 = {
  class: "grid grid-cols-2 md:grid-cols-3 gap-4"
};
const _hoisted_45 = {
  class: "text-sm text-slate-900"
};
const _hoisted_46 = {
  class: "text-sm text-slate-900 font-mono"
};
const _hoisted_47 = {
  class: "text-sm text-slate-900"
};
const _hoisted_48 = {
  key: 0,
  class: "bg-slate-50 rounded-xl p-4"
};
const _hoisted_49 = {
  class: "grid grid-cols-2 gap-4"
};
const _hoisted_50 = {
  class: "text-sm text-slate-900"
};
const _hoisted_51 = {
  key: 0
};
const _hoisted_52 = {
  class: "text-sm text-slate-900"
};
const _hoisted_53 = {
  key: 1,
  class: "bg-red-50 rounded-xl p-4"
};
const _hoisted_54 = {
  class: "flex-shrink-0 px-6 py-4 border-t border-slate-200 flex justify-end gap-3"
};
import { ref, reactive, computed, onMounted } from 'vue';
import { ElMessage, ElMessageBox } from 'element-plus';
import { formatDateTimeText } from '@/utils/dateFormat';
import AppPagination from '@/components/AppPagination.vue';
import ListPageShell from '@/components/ListPageShell.vue';
import PageFilterBar from '@/components/PageFilterBar.vue';
import AppModal from '@/components/AppModal.vue';

// Status mapping (light mode colors)

export default {
  __name: 'WithdrawalReview',
  setup(__props) {
    const statusMap = {
      pending: {
        label: '待审核',
        class: 'status-badge is-warning',
        dot: 'bg-amber-500'
      },
      approved: {
        label: '已通过',
        class: 'status-badge is-success',
        dot: 'bg-green-500'
      },
      rejected: {
        label: '已拒绝',
        class: 'status-badge is-danger',
        dot: 'bg-red-500'
      }
    };

    // Filters
    const filters = reactive({
      status: '',
      dateRange: null,
      amountMin: '',
      amountMax: '',
      keyword: ''
    });

    // Table data (mock)
    const tableData = ref([{
      id: 'WX20260403001',
      userId: '10001',
      userName: '张明',
      amount: 15800,
      fee: 15.80,
      bankName: '中国工商银行',
      bankCardNo: '6222021234567890123',
      bankAccountName: '张明',
      status: 'pending',
      applyTime: '2026-04-03 14:32:15'
    }, {
      id: 'WX20260403002',
      userId: '10002',
      userName: '李华',
      amount: 5600,
      fee: 5.60,
      bankName: '中国建设银行',
      bankCardNo: '6217001234567890123',
      bankAccountName: '李华',
      status: 'approved',
      applyTime: '2026-04-03 11:20:00',
      auditTime: '2026-04-03 11:35:22'
    }, {
      id: 'WX20260403003',
      userId: '10003',
      userName: '王芳',
      amount: 28000,
      fee: 28.00,
      bankName: '中国农业银行',
      bankCardNo: '6228481234567890123',
      bankAccountName: '王芳',
      status: 'pending',
      applyTime: '2026-04-03 10:15:33'
    }, {
      id: 'WX20260402015',
      userId: '10004',
      userName: '刘洋',
      amount: 4200,
      fee: 4.20,
      bankName: '招商银行',
      bankCardNo: '6214851234567890',
      bankAccountName: '刘洋',
      status: 'rejected',
      applyTime: '2026-04-02 16:45:00',
      auditTime: '2026-04-02 17:10:05',
      auditRemark: '银行卡信息错误'
    }, {
      id: 'WX20260402014',
      userId: '10005',
      userName: '陈润',
      amount: 9850,
      fee: 9.85,
      bankName: '交通银行',
      bankCardNo: '6222601234567890123',
      bankAccountName: '陈润',
      status: 'approved',
      applyTime: '2026-04-02 09:30:00',
      auditTime: '2026-04-02 09:45:18'
    }]);
    const loading = ref(false);
    const total = ref(5);
    const pagination = reactive({
      current: 1,
      size: 10,
      pages: 1
    });
    const selectedIds = ref([]);
    const isAllSelected = computed(() => {
      return tableData.value.length > 0 && tableData.value.every(row => selectedIds.value.includes(row.id));
    });

    // Dialog states
    const detailDialogVisible = ref(false);
    const currentRow = ref(null);
    const rejectReason = ref('');
    const showRejectInput = ref(false);

    // Handlers
    function handleSearch() {
      loading.value = true;
      setTimeout(() => {
        loading.value = false;
        ElMessage.success('搜索完成');
      }, 500);
    }
    function handleReset() {
      filters.status = '';
      filters.dateRange = null;
      filters.amountMin = '';
      filters.amountMax = '';
      filters.keyword = '';
      handleSearch();
    }
    function handlePageChange(page) {
      if (page < 1 || page > pagination.pages) return;
      pagination.current = page;
      handleSearch();
    }
    function handlePageSizeChange(size) {
      pagination.size = size;
      pagination.pages = Math.ceil(total.value / pagination.size);
      pagination.current = 1;
      handleSearch();
    }
    function toggleRow(id) {
      const idx = selectedIds.value.indexOf(id);
      if (idx > -1) {
        selectedIds.value.splice(idx, 1);
      } else {
        selectedIds.value.push(id);
      }
    }
    function toggleAllRows(e) {
      if (e.target.checked) {
        selectedIds.value = tableData.value.map(row => row.id);
      } else {
        selectedIds.value = [];
      }
    }
    function handleViewDetail(row) {
      currentRow.value = {
        ...row
      };
      rejectReason.value = '';
      showRejectInput.value = false;
      detailDialogVisible.value = true;
    }
    function handleApprove(row) {
      ElMessageBox.confirm(`确认通过用户"${row.userName}"的提现申请吗？`, '审核确认', {
        confirmButtonText: '确认通过',
        cancelButtonText: '取消',
        type: 'success'
      }).then(() => {
        row.status = 'approved';
        row.auditTime = new Date().toLocaleString();
        ElMessage.success('已通过');
      }).catch(() => {});
    }
    function handleApproveFromDialog() {
      if (!currentRow.value) return;
      ElMessageBox.confirm(`确认通过用户"${currentRow.value.userName}"的提现申请吗？`, '审核确认', {
        confirmButtonText: '确认通过',
        cancelButtonText: '取消',
        type: 'success'
      }).then(() => {
        currentRow.value.status = 'approved';
        currentRow.value.auditTime = new Date().toLocaleString();
        // sync back to table
        const row = tableData.value.find(r => r.id === currentRow.value.id);
        if (row) Object.assign(row, currentRow.value);
        detailDialogVisible.value = false;
        ElMessage.success('已通过');
      }).catch(() => {});
    }
    function handleReject(row) {
      ElMessageBox.confirm('确认拒绝此提现申请吗？', '审核确认', {
        confirmButtonText: '确认拒绝',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        row.status = 'rejected';
        row.auditTime = new Date().toLocaleString();
        row.auditRemark = '';
        ElMessage.success('已拒绝');
      }).catch(() => {});
    }
    function confirmReject() {
      if (!showRejectInput.value) return;
      if (!currentRow.value) return;
      ElMessageBox.confirm(rejectReason.value ? `拒绝原因：${rejectReason.value}` : '确认拒绝此提现申请吗？', '审核确认', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        currentRow.value.status = 'rejected';
        currentRow.value.auditTime = new Date().toLocaleString();
        currentRow.value.auditRemark = rejectReason.value;
        const row = tableData.value.find(r => r.id === currentRow.value.id);
        if (row) Object.assign(row, currentRow.value);
        detailDialogVisible.value = false;
        ElMessage.success('已拒绝');
      }).catch(() => {});
    }
    onMounted(() => {
      pagination.pages = Math.ceil(total.value / pagination.size);
    });
    return (_ctx, _cache) => {
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      const _component_el_date_picker = _resolveComponent("el-date-picker");
      const _directive_permission = _resolveDirective("permission");
      return _openBlock(), _createBlock(ListPageShell, {
        fill: ""
      }, {
        header: _withCtx(() => [...(_cache[10] || (_cache[10] = [_createElementVNode("div", {
          class: "list-page-panel is-header-minimal"
        }, [_createElementVNode("div", {
          class: "list-page-heading"
        }, [_createElementVNode("div", {
          class: "list-page-heading-main"
        }, [_createElementVNode("h1", {
          class: "list-page-title"
        }, "提现审核"), _createElementVNode("p", {
          class: "list-page-description"
        }, "管理用户提现申请，进行审核操作")])])], -1)]))]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createVNode(PageFilterBar, {
          "shell-class": "filter-bar-shell is-embedded",
          "body-class": "filter-bar-body is-panel",
          "show-refresh": true,
          "refresh-loading": loading.value,
          onRefresh: handleSearch
        }, {
          searchActions: _withCtx(() => [_createElementVNode("button", {
            type: "button",
            class: "btn-primary",
            onClick: handleSearch
          }, "搜索"), _createElementVNode("button", {
            type: "button",
            class: "btn-secondary",
            onClick: handleReset
          }, "重置")]),
          default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => filters.keyword = $event),
            type: "text",
            placeholder: "用户ID / 姓名 / 银行",
            class: "form-search-input form-control-sm w-full",
            onKeyup: _withKeys(handleSearch, ["enter"])
          }, null, 544), [[_vModelText, filters.keyword]]), _cache[11] || (_cache[11] = _createElementVNode("svg", {
            class: "absolute left-3 top-2.5 h-4 w-4 text-slate-400",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
          })], -1))]), _createVNode(_component_el_select, {
            modelValue: filters.status,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => filters.status = $event),
            placeholder: "请选择状态",
            class: "form-select form-control-sm filter-bar-field"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_option, {
              label: "全部状态",
              value: ""
            }), _createVNode(_component_el_option, {
              label: "待审核",
              value: "pending"
            }), _createVNode(_component_el_option, {
              label: "已通过",
              value: "approved"
            }), _createVNode(_component_el_option, {
              label: "已拒绝",
              value: "rejected"
            })]),
            _: 1
          }, 8, ["modelValue"]), _createVNode(_component_el_date_picker, {
            modelValue: filters.dateRange,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => filters.dateRange = $event),
            type: "daterange",
            "range-separator": "至",
            "start-placeholder": "开始日期",
            "end-placeholder": "结束日期",
            class: "filter-bar-field is-wide form-date form-control-sm",
            "value-format": "YYYY-MM-DD"
          }, null, 8, ["modelValue"]), _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => filters.amountMin = $event),
            type: "number",
            placeholder: "最低金额",
            class: "form-input form-control-sm filter-bar-field"
          }, null, 512), [[_vModelText, filters.amountMin]]), _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => filters.amountMax = $event),
            type: "number",
            placeholder: "最高金额",
            class: "form-input form-control-sm filter-bar-field"
          }, null, 512), [[_vModelText, filters.amountMax]])]),
          _: 1
        }, 8, ["refresh-loading"]), _createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("table", _hoisted_5, [_createElementVNode("thead", _hoisted_6, [_createElementVNode("tr", null, [_createElementVNode("th", _hoisted_7, [_createElementVNode("input", {
          type: "checkbox",
          onChange: toggleAllRows,
          checked: isAllSelected.value,
          class: "form-check"
        }, null, 40, _hoisted_8)]), _cache[12] || (_cache[12] = _createElementVNode("th", {
          class: "data-table-th text-left"
        }, "ID", -1)), _cache[13] || (_cache[13] = _createElementVNode("th", {
          class: "data-table-th text-left"
        }, "用户信息", -1)), _cache[14] || (_cache[14] = _createElementVNode("th", {
          class: "data-table-th text-right"
        }, "提现金额", -1)), _cache[15] || (_cache[15] = _createElementVNode("th", {
          class: "data-table-th text-left"
        }, "银行", -1)), _cache[16] || (_cache[16] = _createElementVNode("th", {
          class: "data-table-th text-left"
        }, "状态", -1)), _cache[17] || (_cache[17] = _createElementVNode("th", {
          class: "data-table-th text-left"
        }, "申请时间", -1)), _cache[18] || (_cache[18] = _createElementVNode("th", {
          class: "data-table-th text-center data-table-sticky-right data-table-sticky-head data-table-sticky-action"
        }, "操作", -1))])]), _createElementVNode("tbody", null, [loading.value ? (_openBlock(), _createElementBlock(_Fragment, {
          key: 0
        }, _renderList(5, n => {
          return _createElementVNode("tr", {
            key: n,
            class: "animate-pulse"
          }, [...(_cache[19] || (_cache[19] = [_createElementVNode("td", {
            class: "data-table-td is-center"
          }, [_createElementVNode("div", {
            class: "h-4 w-4 bg-slate-200 rounded"
          })], -1), _createElementVNode("td", {
            class: "data-table-td"
          }, [_createElementVNode("div", {
            class: "h-4 w-24 bg-slate-200 rounded"
          })], -1), _createElementVNode("td", {
            class: "data-table-td"
          }, [_createElementVNode("div", {
            class: "flex items-center gap-3"
          }, [_createElementVNode("div", {
            class: "h-8 w-8 bg-slate-200 rounded-full"
          }), _createElementVNode("div", {
            class: "h-4 w-20 bg-slate-200 rounded"
          })])], -1), _createElementVNode("td", {
            class: "data-table-td is-right"
          }, [_createElementVNode("div", {
            class: "h-4 w-16 bg-slate-200 rounded ml-auto"
          })], -1), _createElementVNode("td", {
            class: "data-table-td"
          }, [_createElementVNode("div", {
            class: "h-4 w-32 bg-slate-200 rounded"
          })], -1), _createElementVNode("td", {
            class: "data-table-td is-center"
          }, [_createElementVNode("div", {
            class: "h-6 w-16 bg-slate-200 rounded-full"
          })], -1), _createElementVNode("td", {
            class: "data-table-td"
          }, [_createElementVNode("div", {
            class: "h-4 w-24 bg-slate-200 rounded"
          })], -1), _createElementVNode("td", {
            class: "data-table-td is-center data-table-sticky-right data-table-sticky-action"
          }, [_createElementVNode("div", {
            class: "h-8 w-20 bg-slate-200 rounded"
          })], -1)]))]);
        }), 64)) : tableData.value.length === 0 ? (_openBlock(), _createElementBlock("tr", _hoisted_9, [...(_cache[20] || (_cache[20] = [_createElementVNode("td", {
          colspan: "8",
          class: "data-table-empty"
        }, [_createElementVNode("div", {
          class: "flex flex-col items-center"
        }, [_createElementVNode("svg", {
          class: "w-12 h-12 text-slate-300 mb-3",
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24"
        }, [_createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2",
          d: "M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2"
        })]), _createElementVNode("span", null, "暂无提现记录")])], -1)]))])) : _createCommentVNode("", true), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tableData.value, row => {
          return _openBlock(), _createElementBlock("tr", {
            key: row.id,
            class: "data-table-row"
          }, [_createElementVNode("td", _hoisted_10, [_createElementVNode("input", {
            type: "checkbox",
            checked: selectedIds.value.includes(row.id),
            onChange: $event => toggleRow(row.id),
            class: "form-check"
          }, null, 40, _hoisted_11)]), _createElementVNode("td", _hoisted_12, _toDisplayString(row.id), 1), _createElementVNode("td", _hoisted_13, [_createElementVNode("div", _hoisted_14, [_createElementVNode("div", _hoisted_15, _toDisplayString(row.userName?.charAt(0) || 'U'), 1), _createElementVNode("div", null, [_createElementVNode("div", _hoisted_16, _toDisplayString(row.userName), 1), _createElementVNode("div", _hoisted_17, "ID: " + _toDisplayString(row.userId), 1)])])]), _createElementVNode("td", _hoisted_18, "￥" + _toDisplayString(row.amount?.toLocaleString()), 1), _createElementVNode("td", _hoisted_19, [_createElementVNode("div", _hoisted_20, _toDisplayString(row.bankName), 1), _createElementVNode("div", _hoisted_21, _toDisplayString(row.bankCardNo?.replace(/(\d{4})\d+(\d{4})/, '$1****$2')), 1)]), _createElementVNode("td", _hoisted_22, [_createElementVNode("span", {
            class: _normalizeClass(["status-badge", statusMap[row.status]?.class])
          }, [_createElementVNode("span", {
            class: _normalizeClass(["w-1.5 h-1.5 rounded-full mr-1", statusMap[row.status]?.dot])
          }, null, 2), _createTextVNode(" " + _toDisplayString(statusMap[row.status]?.label), 1)], 2)]), _createElementVNode("td", _hoisted_23, _toDisplayString(_unref(formatDateTimeText)(row.applyTime)), 1), _createElementVNode("td", _hoisted_24, [_createElementVNode("div", _hoisted_25, [row.status === 'pending' ? _withDirectives((_openBlock(), _createElementBlock("button", {
            key: 0,
            class: "table-action-button is-success",
            title: "通过",
            "aria-label": "通过",
            onClick: $event => handleApprove(row)
          }, [...(_cache[21] || (_cache[21] = [_createElementVNode("svg", {
            class: "w-4 h-4",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M5 13l4 4L19 7"
          })], -1)]))], 8, _hoisted_26)), [[_directive_permission, 'commission:withdraw:audit']]) : _createCommentVNode("", true), row.status === 'pending' ? _withDirectives((_openBlock(), _createElementBlock("button", {
            key: 1,
            class: "table-action-button is-danger",
            title: "拒绝",
            "aria-label": "拒绝",
            onClick: $event => handleReject(row)
          }, [...(_cache[22] || (_cache[22] = [_createElementVNode("svg", {
            class: "w-4 h-4",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M6 18L18 6M6 6l12 12"
          })], -1)]))], 8, _hoisted_27)), [[_directive_permission, 'commission:withdraw:audit']]) : _createCommentVNode("", true), _createElementVNode("button", {
            class: "table-action-button is-primary",
            title: "查看详情",
            "aria-label": "查看详情",
            onClick: $event => handleViewDetail(row)
          }, [...(_cache[23] || (_cache[23] = [_createElementVNode("svg", {
            class: "w-4 h-4",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M15 12a3 3 0 11-6 0 3 3 0 016 0z"
          }), _createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
          })], -1)]))], 8, _hoisted_28)])])]);
        }), 128))])])])]), _createVNode(AppPagination, {
          class: "pagination-bridge",
          pagination: pagination,
          total: total.value,
          "page-sizes": [10, 20, 50],
          onPageChange: handlePageChange,
          onSizeChange: handlePageSizeChange
        }, null, 8, ["pagination", "total"])]), (_openBlock(), _createBlock(_Teleport, {
          to: "body"
        }, [_createVNode(AppModal, {
          visible: detailDialogVisible.value,
          size: "2xl",
          onClose: _cache[9] || (_cache[9] = $event => detailDialogVisible.value = false)
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_29, [_createElementVNode("div", null, [_cache[24] || (_cache[24] = _createElementVNode("h3", {
            class: "text-lg font-semibold text-slate-900"
          }, "提现详情", -1)), _createElementVNode("p", _hoisted_30, _toDisplayString(currentRow.value?.id), 1)]), _createElementVNode("div", _hoisted_31, [currentRow.value ? (_openBlock(), _createElementBlock("span", {
            key: 0,
            class: _normalizeClass(["inline-flex items-center px-3 py-1 rounded-full text-sm font-medium", statusMap[currentRow.value.status]?.class])
          }, [_createElementVNode("span", {
            class: _normalizeClass(["w-2 h-2 rounded-full mr-1.5", statusMap[currentRow.value.status]?.dot])
          }, null, 2), _createTextVNode(" " + _toDisplayString(statusMap[currentRow.value.status]?.label), 1)], 2)) : _createCommentVNode("", true), _createElementVNode("button", {
            class: "p-1.5 text-slate-400 hover:text-slate-600",
            onClick: _cache[5] || (_cache[5] = $event => detailDialogVisible.value = false)
          }, [...(_cache[25] || (_cache[25] = [_createElementVNode("svg", {
            class: "w-5 h-5",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M6 18L18 6M6 6l12 12"
          })], -1)]))])])]), _createElementVNode("div", _hoisted_32, [_createElementVNode("div", _hoisted_33, [_cache[28] || (_cache[28] = _createElementVNode("h4", {
            class: "text-sm font-medium text-slate-700 mb-3 flex items-center"
          }, [_createElementVNode("svg", {
            class: "w-4 h-4 mr-2 text-slate-400",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
          })]), _createTextVNode(" 用户信息 ")], -1)), _createElementVNode("div", _hoisted_34, [_createElementVNode("div", null, [_cache[26] || (_cache[26] = _createElementVNode("div", {
            class: "text-xs text-slate-500 mb-1"
          }, "用户ID", -1)), _createElementVNode("div", _hoisted_35, _toDisplayString(currentRow.value?.userId || '-'), 1)]), _createElementVNode("div", null, [_cache[27] || (_cache[27] = _createElementVNode("div", {
            class: "text-xs text-slate-500 mb-1"
          }, "用户姓名", -1)), _createElementVNode("div", _hoisted_36, _toDisplayString(currentRow.value?.userName || '-'), 1)])])]), _createElementVNode("div", _hoisted_37, [_cache[33] || (_cache[33] = _createElementVNode("h4", {
            class: "text-sm font-medium text-slate-700 mb-3 flex items-center"
          }, [_createElementVNode("svg", {
            class: "w-4 h-4 mr-2 text-slate-400",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
          })]), _createTextVNode(" 提现信息 ")], -1)), _createElementVNode("div", _hoisted_38, [_createElementVNode("div", null, [_cache[29] || (_cache[29] = _createElementVNode("div", {
            class: "text-xs text-slate-500 mb-1"
          }, "提现金额", -1)), _createElementVNode("div", _hoisted_39, "￥" + _toDisplayString(currentRow.value?.amount?.toLocaleString() || '0'), 1)]), _createElementVNode("div", null, [_cache[30] || (_cache[30] = _createElementVNode("div", {
            class: "text-xs text-slate-500 mb-1"
          }, "手续费", -1)), _createElementVNode("div", _hoisted_40, "￥" + _toDisplayString(currentRow.value?.fee?.toLocaleString() || '0.00'), 1)]), _createElementVNode("div", null, [_cache[31] || (_cache[31] = _createElementVNode("div", {
            class: "text-xs text-slate-500 mb-1"
          }, "实际到账", -1)), _createElementVNode("div", _hoisted_41, "￥" + _toDisplayString(((currentRow.value?.amount || 0) - (currentRow.value?.fee || 0)).toLocaleString()), 1)]), _createElementVNode("div", null, [_cache[32] || (_cache[32] = _createElementVNode("div", {
            class: "text-xs text-slate-500 mb-1"
          }, "申请时间", -1)), _createElementVNode("div", _hoisted_42, _toDisplayString(currentRow.value?.applyTime || '-'), 1)])])]), _createElementVNode("div", _hoisted_43, [_cache[37] || (_cache[37] = _createElementVNode("h4", {
            class: "text-sm font-medium text-slate-700 mb-3 flex items-center"
          }, [_createElementVNode("svg", {
            class: "w-4 h-4 mr-2 text-slate-400",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z"
          })]), _createTextVNode(" 银行卡信息 ")], -1)), _createElementVNode("div", _hoisted_44, [_createElementVNode("div", null, [_cache[34] || (_cache[34] = _createElementVNode("div", {
            class: "text-xs text-slate-500 mb-1"
          }, "开户银行", -1)), _createElementVNode("div", _hoisted_45, _toDisplayString(currentRow.value?.bankName || '-'), 1)]), _createElementVNode("div", null, [_cache[35] || (_cache[35] = _createElementVNode("div", {
            class: "text-xs text-slate-500 mb-1"
          }, "卡号", -1)), _createElementVNode("div", _hoisted_46, _toDisplayString(currentRow.value?.bankCardNo || '-'), 1)]), _createElementVNode("div", null, [_cache[36] || (_cache[36] = _createElementVNode("div", {
            class: "text-xs text-slate-500 mb-1"
          }, "开户姓名", -1)), _createElementVNode("div", _hoisted_47, _toDisplayString(currentRow.value?.bankAccountName || '-'), 1)])])]), currentRow.value?.status !== 'pending' ? (_openBlock(), _createElementBlock("div", _hoisted_48, [_cache[40] || (_cache[40] = _createElementVNode("h4", {
            class: "text-sm font-medium text-slate-700 mb-3 flex items-center"
          }, [_createElementVNode("svg", {
            class: "w-4 h-4 mr-2 text-slate-400",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
          })]), _createTextVNode(" 审核信息 ")], -1)), _createElementVNode("div", _hoisted_49, [_createElementVNode("div", null, [_cache[38] || (_cache[38] = _createElementVNode("div", {
            class: "text-xs text-slate-500 mb-1"
          }, "审核时间", -1)), _createElementVNode("div", _hoisted_50, _toDisplayString(currentRow.value?.auditTime || '-'), 1)]), currentRow.value?.auditRemark ? (_openBlock(), _createElementBlock("div", _hoisted_51, [_cache[39] || (_cache[39] = _createElementVNode("div", {
            class: "text-xs text-slate-500 mb-1"
          }, "审核备注", -1)), _createElementVNode("div", _hoisted_52, _toDisplayString(currentRow.value.auditRemark), 1)])) : _createCommentVNode("", true)])])) : _createCommentVNode("", true), showRejectInput.value ? (_openBlock(), _createElementBlock("div", _hoisted_53, [_cache[41] || (_cache[41] = _createElementVNode("h4", {
            class: "text-sm font-medium text-red-700 mb-3"
          }, "拒绝原因", -1)), _withDirectives(_createElementVNode("textarea", {
            "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => rejectReason.value = $event),
            rows: "3",
            placeholder: "请输入拒绝原因（选填）",
            class: "w-full px-3 py-2 border border-red-200 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-red-500 focus:border-transparent resize-none"
          }, null, 512), [[_vModelText, rejectReason.value]])])) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_54, [_createElementVNode("button", {
            class: "btn-secondary",
            onClick: _cache[7] || (_cache[7] = $event => detailDialogVisible.value = false)
          }, "关闭"), currentRow.value?.status === 'pending' ? (_openBlock(), _createElementBlock(_Fragment, {
            key: 0
          }, [_withDirectives((_openBlock(), _createElementBlock("button", {
            class: "btn-danger-secondary",
            onClick: _cache[8] || (_cache[8] = $event => {
              showRejectInput.value = true;
              showRejectInput.value && confirmReject();
            })
          }, [...(_cache[42] || (_cache[42] = [_createTextVNode("拒绝", -1)]))])), [[_directive_permission, 'commission:withdraw:audit']]), _withDirectives((_openBlock(), _createElementBlock("button", {
            class: "btn-primary",
            onClick: handleApproveFromDialog
          }, [...(_cache[43] || (_cache[43] = [_createTextVNode("通过", -1)]))])), [[_directive_permission, 'commission:withdraw:audit']])], 64)) : _createCommentVNode("", true)])]),
          _: 1
        }, 8, ["visible"])]))]),
        _: 1
      });
    };
  }
};